(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pl-recipe-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async function(event) {
    const form = event.target;
    if (!form.matches('form[data-pl-recipe-form]') || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    form.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const endpoint = new URL(form.action, location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
      const response = await fetch(endpoint.href, {
        method: 'POST', body: new FormData(form), credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || status.dataset.error);
      }
      status.textContent = status.dataset.added;
      if (document.getElementById('CartDrawer')) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: button }
        }));
      } else {
        location.assign(form.dataset.cartUrl);
      }
    } catch (error) {
      status.textContent = error.message && error.name === 'Error' ? error.message : status.dataset.error;
    } finally {
      form.dataset.pending = 'false';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-reorder"]) return;
  try {
    
  (function() {
    let pending = false;
    document.addEventListener('submit', async function(event) {
      const form = event.target;
      if (!form.matches('form[data-pl-reorder-form]') || !window.fetch) return;
      event.preventDefault();
      if (pending || form.dataset.uncertain === 'true' || !form.reportValidity()) return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      let confirmed = false;
      try {
        const endpoint = new URL(form.action, location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
        const response = await fetch(endpoint.href, {
          method: 'POST', body: new FormData(form), credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) {
          if (response.status >= 400 && response.status < 500) {
            confirmed = true;
            status.textContent = typeof data.description === 'string' ? data.description : status.dataset.error;
          } else {
            throw new Error('Unconfirmed cart result');
          }
          return;
        }
        if (!data.id) throw new Error('Unconfirmed cart result');
        confirmed = true;
        status.textContent = status.dataset.added;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: button } }));
      } catch (error) {
        if (!confirmed) {
          form.dataset.uncertain = 'true';
          status.textContent = status.dataset.uncertain;
        }
      } finally {
        pending = false;
        button.disabled = form.dataset.uncertain === 'true';
        button.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
